
import { defineComponent, computed } from 'vue'

import JrRadioGroup from '@/components/jr-parts/JrRadioGroup.vue'

import { ScheduleTypes } from '@/constants/enums'
import { formatDateWithDay } from '@/services/date'

/** ラベル定義 */
const labels = Object.freeze([
  Object.freeze({ value: ScheduleTypes.ALL, text: '終日OK', disabled: false }),
  Object.freeze({ value: ScheduleTypes.AM, text: 'AMのみ', disabled: false }),
  Object.freeze({ value: ScheduleTypes.PM, text: 'PMのみ', disabled: false }),
  Object.freeze({ value: ScheduleTypes.NONE, text: 'NG', disabled: false }),
])

/**
 * ラベルが非活性かどうかを返す
 */
const isDisabledLabel = (selectableTimeType: number, targetValue: number): boolean => {
  if (selectableTimeType === ScheduleTypes.ALL) {
    // 全ての場合は全て活性
    return false
  } else if (selectableTimeType === ScheduleTypes.AM) {
    // AMのみならAMと不可以外非活性
    return targetValue !== ScheduleTypes.AM && targetValue !== ScheduleTypes.NONE
  } else if (selectableTimeType === ScheduleTypes.PM) {
    // PMのみならPMと不可以外非活性
    return targetValue !== ScheduleTypes.PM && targetValue !== ScheduleTypes.NONE
  } else {
    // その他は非活性
    return true
  }
}

/**
 * 候補日選択コンポーネント
 */
export default defineComponent({
  name: 'ScheduleRadio',
  emits: ['update:modelValue'],
  components: { JrRadioGroup },
  props: {
    // 日付
    date: {
      type: String,
      required: true,
    },
    // 選択値
    modelValue: {
      type: Number,
      required: false,
      default: null,
    },
    // 編集可能か
    isEdit: {
      type: Boolean,
      required: false,
      default: true,
    },
    // 「不可」選択が可能か
    canNotPossible: {
      type: Boolean,
      required: true,
    },
    // 選択可能候補
    selectableTimeType: {
      type: Number,
      required: false,
      default: null,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    // 日付を表示するか
    isDateVisible: {
      type: Boolean,
      required: false,
      default: true,
    },
    size: {
      type: String,
      required: false,
      default: 'medium',
    },
  },
  setup(props, context) {
    const selectableLabels = computed(() => {
      return labels
        .filter((label) => {
          // 不可選択可能時は全て、そうでは無い場合は不可以外を出す
          return props.canNotPossible || label.value !== ScheduleTypes.NONE
        })
        .map((label) => {
          const disableLabel = { ...label }
          if (props.selectableTimeType != null) {
            // 選択可能な時間帯かどうか判定
            disableLabel.disabled = isDisabledLabel(props.selectableTimeType, label.value)
          } else {
            disableLabel.disabled = false
          }
          return disableLabel
        })
    })

    const formatedDate = computed(() => {
      return formatDateWithDay(props.date)
    })

    return {
      formatedDate,
      selectableLabels,
      update: (type: number) => {
        // 選択したvalueを返す
        context.emit('update:modelValue', type)
      },
    }
  },
})
